import Vue from "vue";
import Router from "vue-router";
import FuseeGelee from "./components/FuseeGelee.vue";
import IncompatibleBrowser from "./components/IncompatibleBrowser.vue";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "fusee-gelee",
      component: FuseeGelee
    },
    {
      path: "/incompatible-browser",
      name: "incompatible-browser",
      component: IncompatibleBrowser
    }
  ]
});
